import { SafetyLocalStorage } from '@mail-core/std';
import { Button } from '@vkontakte/vkui';
import familyAddImg from 'img/tooltip/family-add.png';
import React, { forwardRef, useCallback, useEffect } from 'react';
import { getIdByStorage } from 'reactApp/modules/storage/storage.helpers';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { store as reduxStore } from 'reactApp/store';
import { FloatingTooltip } from 'reactApp/ui/FloatingTooltip/FloatingTooltip';
import { ETooltipPlacement, ETooltipSize } from 'reactApp/ui/FloatingTooltip/FloatingTooltip.types';
import { sendDwh } from 'reactApp/utils/ga';
import { ECategoryGa } from 'reactApp/utils/paymentGa';

import styles from './FamilyAddButtonTooltip.css';

interface FamilyAddButtonTooltipProps {
    onClose?: () => void;
    onShow?: () => void;
    onClick?: () => void;
    onCrossClose?: () => void;
    leftOffset?: number;
    placement?: ETooltipPlacement;
    closeOnOutsideClick?: boolean;
    targetSelector?: string;
}

const TOOLTIP_CLOSED_KEY = 'family_add_button_tooltip_closed';

const state = reduxStore.getState();
const email = UserSelectors.getEmail(state);
const lStorage = new SafetyLocalStorage({});

export const FamilyAddButtonTooltip = forwardRef<HTMLDivElement, FamilyAddButtonTooltipProps>(
    ({
        onClose,
        onShow,
        onClick,
        onCrossClose,
        leftOffset,
        placement = ETooltipPlacement.rightStart,
        closeOnOutsideClick = true,
        targetSelector = '[data-qa-id="family-add-button"]',
    }) => {
        useEffect(() => {
            sendDwh({
                eventCategory: ECategoryGa.tooltip,
                action: 'show',
                dwh_enabled: true,
                dwhData: { name: 'family_add_members_aon' },
            });
            onShow?.();
        }, [onShow]);

        const handleAddClick = useCallback(() => {
            sendDwh({
                eventCategory: ECategoryGa.tooltip,
                action: 'click',
                dwh_enabled: true,
                dwhData: { name: 'family_add_members_aon' },
            });
            onClick?.();
            lStorage.setItem(`${email}|${TOOLTIP_CLOSED_KEY}`, 'true');
            const url = getIdByStorage(EStorageType.family);
            if (typeof window !== 'undefined' && window.location) {
                window.location.assign(url);
            }
        }, [onClick]);

        const handleCrossClose = useCallback(() => {
            lStorage.setItem(`${email}|${TOOLTIP_CLOSED_KEY}`, 'true');
            onCrossClose?.();
        }, [onCrossClose]);

        const handleClose = useCallback(() => {
            sendDwh({
                eventCategory: ECategoryGa.tooltip,
                action: 'close',
                dwh_enabled: true,
                dwhData: { name: 'family_add_members_aon' },
            });
            onClose?.();
        }, [onClose]);

        const targetRef = document.querySelector(targetSelector) as HTMLDivElement;

        return (
            <FloatingTooltip
                target={targetRef}
                placement={placement}
                size={ETooltipSize.fit}
                onClose={handleClose}
                onShow={onShow}
                onCrossClose={handleCrossClose}
                usePortal
                qaId="family-add-button-tooltip"
                leftOffset={leftOffset}
                closeOnOutsideClick={closeOnOutsideClick}
            >
                <div className={styles.root}>
                    <div className={styles.textBlock}>
                        <div className={styles.title}>Добавьте ещё 3 близких</div>
                        <div className={styles.text}>Подпиской можно пользоваться вчетвером — место и функции общие</div>
                    </div>
                    <Button onClick={handleAddClick} className={styles.button} size="l" stretched={false}>
                        Добавить
                    </Button>
                    <img className={styles.image} src={familyAddImg} alt="Семья" />
                </div>
            </FloatingTooltip>
        );
    }
);

FamilyAddButtonTooltip.displayName = 'FamilyAddButtonTooltip';
